import gsap, { Expo } from 'gsap';
import { ControllerPage } from '../_app/cuchillo/pages/ControllerPage';
import Default from './Default';
import { SplitText } from 'gsap/SplitText';
import { GetBy } from '../_app/cuchillo/core/Element';
import { Ease } from '../_app/cuchillo/utils/Ease';
import Header from '../layout/Header';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import Keyboard from '../_app/cuchillo/core/Keyboard';
import Scene from '../3D/Scene';

gsap.registerPlugin(SplitText);

export default class Manifiesto extends Default {

  //==================================================================================================================
  //          CONSTRUCTOR
  //==================================================================================================================

  constructor() {
    super();
    this.video = GetBy.class("holder-video")[0];
    this.manifiesto = GetBy.class("block-manifiesto__manifiesto-holder")[0];
    this.timeline = gsap.timeline({ paused: true });
    this.setupText();
    Header.directHide();
  }

  setupText() {
    this._title = new SplitText(GetBy.class('manifiesto', this.container)[0], {
      type: 'words',
      wordsClass: 'line-child'
    }).words;

    const tempHeight = this._title[0].offsetHeight;

    let delay = 1;
    this.timeline.to(this.video, {
      opacity: 1,
      duration: 1,
      force3D: true,
      ease: Ease.EASE_CUCHILLO_IN_OUT
    }, delay);

    delay += .4;
    this.timeline.from(this.manifiesto, {
      y: "+50%",
      x: "-20%",
      duration: 1,
      force3D: true,
      ease: Expo.easeOut
    }, delay);
    delay += .2;
    this.timeline.from(this.manifiesto, {
      opacity: 0,
      duration: .4,
      force3D: true,
      ease: Ease.EASE_CUCHILLO_IN_OUT
    }, delay);

    delay += .2;
    this._title.map(dom => {
      this.timeline.from(dom, {
        y: tempHeight * 3,
        duration: 1,
        rotate: 20,
        force3D: true,
        ease: Ease.EASE_CUCHILLO_IN_OUT
      }, delay);

      delay += 0.08;
    });
  }

  beforeShow() {
    Scroll.init(Scroll.AXIS_Y, { domResize: this.container, smooth: true, multiplicator: 1 });
    Keyboard.mountPage(this.id);

    // No crida super.beforeShow(): amaguem character i BGSphere explícitament (com fa Default)
    Scene.hideCharacter();
    Scene.hideBGSphere();

    this.timeline.restart();
  }
}

ControllerPage._addPage('page-manifiesto', Manifiesto)
